import { OrderDetails } from '@app/entities/orders/interfaces/order-details';
import { OrderItem } from '@app/entities/orders/interfaces/order-item';

export const sumPrice = (orderDetails: OrderDetails): number => {
  return orderDetails.items.reduce(
    (previousValue: number, currentValue: OrderItem) => {
      return previousValue + currentValue.price;
    },
    0,
  );
};
